import { createReducer } from 'typesafe-actions';
import { combineReducers } from 'redux';
import { defaultErrorHandler, defaultRequestHandler } from '../dataFetching/generators';
import { LinkedBanners } from '../seo/types';
import { cmsLinkedBannersActions, CmsLinkedBannerActions, CmsStaticPageActions, cmsStaticPageActions } from './actions';
import {
    CMSBlockState,
    CmsStaticPageResponseData,
    CmsLinkedBannersResponseData,
    CmsLinkedBannersState,
    CMSStaticPageState,
} from './types';

const defaultFieldState = {
    isFetching: false,
    didInvalidate: false,
    error: null,
    identifier: '',
    data: {},
};

export const parseCmsLinkBanners = (data: CmsLinkedBannersResponseData) => {
    const linkedBannners: LinkedBanners[] = data.linkedBanners.map(linkBanner => {
        return {
            bannerImage: linkBanner.linked_banners_banner_image,
            bannerLink: linkBanner.linked_banners_banner_link,
            desktopBannerImage: linkBanner.linked_banners_banner_desktop_image,
        };
    });

    return linkedBannners;
};

const linkedBannersReducer = createReducer<CmsLinkedBannersState, CmsLinkedBannerActions>(defaultFieldState)
    .handleAction(cmsLinkedBannersActions.actions.success, (state, action) => {
        const response = action.payload.data;
        const data = response && (response.data as CmsLinkedBannersResponseData);
        return {
            ...state,
            data: { [action.payload.identifier]: parseCmsLinkBanners(data) },
        };
    })
    .handleAction(cmsLinkedBannersActions.actions.failure, (state, action) => defaultErrorHandler(state, action))
    .handleAction(cmsLinkedBannersActions.actions.request, (state, action) => defaultRequestHandler(state, action));

const staticPageReducer = createReducer<CMSStaticPageState, CmsStaticPageActions>(defaultFieldState)
    .handleAction(cmsStaticPageActions.actions.success, (state, action) => {
        const response = action.payload.data;
        const data = response && (response.data as CmsStaticPageResponseData);

        return {
            ...state,
            data: { [action.payload.identifier]: data.items },
        };
    })
    .handleAction(cmsStaticPageActions.actions.failure, (state, action) => defaultErrorHandler(state, action))
    .handleAction(cmsStaticPageActions.actions.request, (state, action) => defaultRequestHandler(state, action));

const cmsReducer = combineReducers<CMSBlockState>({
    linkedBanners: linkedBannersReducer,
    staticPages: staticPageReducer,
});

export default cmsReducer;
